
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { createContext } from 'react';

/**
 * Internal, exported only for usage in Framer
 */
var SwitchLayoutGroupContext = createContext({});

export { SwitchLayoutGroupContext };
//# sourceMappingURL=SwitchLayoutGroupContext.mjs.js.map
